const questions = [
	"I think about bad things and can’t stop.",
	"I feel like I must wash and clean over and over again.",
	"I collect so much stuff that it gets in the way.",
	"I check many things over and over again.",
	"After I have done things, I’m not sure if I really did them.",
	"I need to count while I do things.",
	"I collect things I don’t really need.",
	"I get upset if my stuff is not in the right order.",
	"I get behind in my school-work because I repeat things over and over again.",
	"I worry a lot about things being clean.",
	"I’m upset by bad thoughts.",
	"I have to say some numbers over and over.",
	"Ever after I’m done I still worry that I didn’t finish things.",
	"I get upset by bad thoughts that pop into my head.",
	"I check doors, windows, and drawers over and over again.",
	"I don’t throw things away because I’m afraid I might need them later.",
	"I get upset if people change the way I arrange things.",
	"If a bad thought comes into my head, I need to say certain things over and over.",
	"I need things to be in a certain way.",
	"Even when I do something very carefully, I don’t think I did it right.",
	"I wash my hands more than other kids.",
]

const domains = [
	["checking", "Doubting/Checking", [4, 5, 13, 15, 20]],
	["obsessing", "Obsessing", [1, 11, 14, 18]],
	["hoarding", "Hoarding", [3, 7, 16]],
	["washing", "Washing", [2, 10, 21]],
	["ordering", "Ordering", [8, 17, 19]],
	["neutralising", "Neutralising", [6, 9, 12]],
]

export function createOciCvConfig() {
	return {
		title: "Obsessive-Compulsive Inventory – Child Version (OCI-CV)",
		fields: [{id: "ociCvTitle", type: "TITLE", title: "OCI-CV"}],
		frequencyInventory: {
			isAdapted: false,
			instructions: "Read each sentence carefully and tell us how much it has happened to you in the last month. This is not a test, so there are no right and wrong answers.",
			questions: questions.map((text, index) => ({id: `q${index + 1}`, text})),
			totalQuestionIds: questions.map((_, index) => `q${index + 1}`),
			options: [{id: "never", title: "Never", value: 0}, {id: "sometimes", title: "Sometimes", value: 1}, {id: "always", title: "Always", value: 2}],
			domains: domains.map(([id, title, numbers]) => ({id, title, questionIds: numbers.map(number => `q${number}`)})),
			purpose: "assessment",
			purposeOptions: [{id: "assessment", title: "Assessment"}, {id: "monitoring", title: "Monitoring"}],
			allowPartial: false,
			sourceLabel: "Child/adolescent self-report",
			returnInstructions: "Return the completed form to your practitioner.",
			totalLabel: "Total score",
			missingLabel: "Unanswered items",
			withheldLabel: "Withheld — unanswered items",
			answeredLabel: "answered",
			unansweredLabel: "Unanswered",
			responsesLabel: "Responses",
			historyLabel: "Previous administrations",
			adaptedLabel: "Practitioner-configured version",
			changeLabel: "change",
		},
	}
}

export function createOciCvDemoPayload() {
	return {form: createOciCvConfig(), answers: Object.fromEntries(questions.map((_, index) => [`q${index + 1}`, ["never", "sometimes", "always"][(index + 1) % 3]])), completedDate: new Date().toISOString().slice(0, 10)}
}
